"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyPriceWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../commonFunctions");
var InfoModal_1 = require("../components/modals/InfoModal");
var PricingExplainedInfo_1 = require("../components/PricingExplainedInfo");
var RentersPricingExplainedRenderers_1 = require("../components/modals/renderers/RentersPricingExplainedRenderers");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var journey_services_1 = require("@athena-portal/journey-services");
var PricingExplainedRenderers_1 = require("../components/modals/renderers/PricingExplainedRenderers");
var NoPriceForMotorTierModal_1 = require("./annual/motor/NoPriceForMotorTierModal");
var StickyPriceWidget = exports.StickyPriceWidget = /** @class */ (function (_super) {
    __extends(StickyPriceWidget, _super);
    function StickyPriceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.visibilityBreakPoint = 250;
        _this.previousPremium = 0;
        _this.renderInfoText = function () {
            if (services_1.productHelper.isMotor(_this.props.interaction)) {
                if (_this.state.displayMtaPremium) {
                    return React.createElement(PricingExplainedInfo_1.PricingExplainedInfo, { interaction: _this.props.interaction, subscription: _this.state.subscription, policies: _this.state.policies });
                }
                else {
                    return (0, PricingExplainedRenderers_1.renderPricingExplained)(_this.props.interaction);
                }
            }
            else if (services_1.productHelper.isRenters(_this.props.interaction)) {
                return (0, RentersPricingExplainedRenderers_1.renderRentersPricingExplained)(_this.props.interaction);
            }
            else {
                return React.createElement(React.Fragment, null);
            }
        };
        _this.showOnScroll = function () {
            if (_this.state.visibilityClass === "d-none") {
                if (window.scrollY > _this.visibilityBreakPoint) {
                    _this.setState({ visibilityClass: "show" });
                }
            }
            else {
                if (window.scrollY > _this.visibilityBreakPoint) {
                    _this.setState({ visibilityClass: "show" });
                }
                else {
                    _this.setState({ visibilityClass: "hide" });
                }
            }
            var tierTableElements = document.getElementsByClassName("tier-table");
            if (tierTableElements.length > 0) {
                var tierTable = tierTableElements[0];
                var tierRect = tierTable.getBoundingClientRect();
                var showTierPremiums = tierRect.top <= 0 && tierRect.bottom >= 0;
                _this.setState({ showTierPremiums: showTierPremiums });
            }
        };
        _this.toggleNoPriceForTierModal = function () {
            _this.setState({
                showNoPriceForTierModal: !_this.state.showNoPriceForTierModal
            });
        };
        if ((0, commonFunctions_1.isAnnualProduct)(_this.props.interaction.product)) {
            _this.previousPremium = _this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL ?
                _this.props.interaction.factors.annualPremium : _this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
        }
        _this.state = {
            premium: _this.props.interaction.factors.premium,
            visibilityClass: "d-none",
            rotationClass: "",
            displayMtaPremium: _this.getSetting("showMtaPremium", false),
            showAdditionalPremium: _this.getSetting("showAdditionalPremium", false),
            showReplaceCarMessage: _this.getSetting("showReplaceCarMessage", false),
            subProcess: _this.props.interaction.subProcess,
            additionalPremiumAmount: _this.props.interaction.factors.additionalPremium,
            refundAmount: _this.props.interaction.factors.returnPremium,
            showTierPremiums: false,
            showNoPriceForTierModal: false,
            initialTier: _this.props.interaction.coverTier,
        };
        window.addEventListener("scroll", _this.showOnScroll);
        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }
    StickyPriceWidget.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.interaction.factors.premium !== this.props.interaction.factors.premium ||
            prevProps.interaction.factors.additionalPremium !== this.props.interaction.factors.additionalPremium ||
            prevProps.interaction.subProcess !== prevProps.interaction.subProcess) {
            this.setState({ rotationClass: "rotate" });
        }
    };
    StickyPriceWidget.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.interaction.process !== services_1.INTERACTION_PROCESS_NB) {
            this.customerPortalService.getSubscription().subscribe(function (subscription) {
                if (subscription) {
                    _this.setState({ subscription: subscription });
                }
            });
            this.customerPortalService.getPolicies().subscribe(function (policies) {
                if (policies) {
                    _this.setState({ policies: policies });
                }
            });
        }
    };
    StickyPriceWidget.prototype.render = function () {
        var _this = this;
        if (this.state.rotationClass === "rotate") {
            setTimeout(function () {
                _this.setState({
                    premium: _this.props.interaction.factors.premium,
                    additionalPremiumAmount: _this.props.interaction.factors.additionalPremium,
                    subProcess: _this.props.interaction.subProcess,
                    refundAmount: _this.props.interaction.factors.returnPremium
                });
            }, 500);
            setTimeout(function () {
                _this.setState({ rotationClass: "" });
            }, 1000);
        }
        var cssClass = this.getSetting("cssClass", "");
        return (React.createElement("div", { className: "sticky-price ".concat(cssClass, " ").concat(this.state.visibilityClass).concat(this.state.showTierPremiums ? " tiers pt-0" : "") },
            React.createElement("div", { className: this.state.showTierPremiums ? "container" : "sticky-price-background" }, this.state.showTierPremiums
                ? this.renderTiers()
                : this.renderStickyPrice()),
            services_1.productHelper.isMotor(this.props.interaction) &&
                React.createElement(NoPriceForMotorTierModal_1.default, { closeModal: this.toggleNoPriceForTierModal, isOpen: this.state.showNoPriceForTierModal, isNB: this.props.interaction.process === services_1.INTERACTION_PROCESS_NB, interaction: this.props.interaction })));
    };
    StickyPriceWidget.prototype.renderStickyPrice = function () {
        var eligibleTiers = (0, commonFunctions_1.getEligibleTiers)(this.props.interaction);
        if ((services_1.productHelper.isWolfMotor(this.props.interaction) && !this.props.interaction.uistate.selectedCoverTier && eligibleTiers.length > 1) || this.previousPremium === 0) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d-inline-block ".concat(this.state.rotationClass) },
                this.premiumToRender(),
                this.additionalWording()),
            React.createElement("div", null,
                !(0, commonFunctions_1.isAnnualProduct)(this.props.interaction.product) && this.wordingToRender(),
                !(0, commonFunctions_1.isAnnualProduct)(this.props.interaction.product) && this.state.subProcess === "existingSubscription" &&
                    React.createElement(InfoModal_1.InfoModal, { className: "mb-2 ml-2", title: "Pricing explained" }, this.renderInfoText()))));
    };
    StickyPriceWidget.prototype.premiumToRender = function () {
        if (!(0, commonFunctions_1.isAnnualProduct)(this.props.interaction.product) && this.state.displayMtaPremium || (this.state.showAdditionalPremium && this.state.additionalPremiumAmount)) {
            return this.state.refundAmount > 0 ?
                (0, commonFunctions_1.getAmountToDisplay)(this.state.refundAmount) :
                (0, commonFunctions_1.getAmountToDisplay)(this.state.additionalPremiumAmount);
        }
        else if ((0, commonFunctions_1.isAnnualProduct)(this.props.interaction.product)) {
            var premiumToDisplay = void 0;
            if (this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL) {
                premiumToDisplay = this.props.interaction.factors.annualPremium === 0 ?
                    this.previousPremium : this.props.interaction.factors.annualPremium;
            }
            else {
                premiumToDisplay = this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment === 0 ?
                    this.previousPremium : this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
            }
            this.previousPremium = premiumToDisplay;
            return (0, commonFunctions_1.getAmountToDisplay)(premiumToDisplay);
        }
        else {
            return (0, commonFunctions_1.getAmountToDisplay)(this.state.premium);
        }
    };
    StickyPriceWidget.prototype.wordingToRender = function () {
        if (this.state.displayMtaPremium || (this.state.showAdditionalPremium && this.state.additionalPremiumAmount) && !this.state.showReplaceCarMessage) {
            return this.state.refundAmount > 0 ? "Refund for this change" : "For this change";
        }
        else if (this.state.showReplaceCarMessage) {
            return "Price for replacing your car";
        }
        else {
            return "For the first month";
        }
    };
    StickyPriceWidget.prototype.additionalWording = function () {
        if ((0, commonFunctions_1.isAnnualProduct)(this.props.interaction.product)) {
            return (React.createElement("span", { className: "fs-18" }, this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL ? " / year" : " / month"));
        }
        return React.createElement(React.Fragment, null);
    };
    StickyPriceWidget.prototype.filterEligibleTiers = function (tiers) {
        var eligibleTiers = (0, commonFunctions_1.getEligibleTiers)(this.props.interaction);
        return new Map(Array.from(tiers).filter(function (_a) {
            var tierKey = _a[0];
            return eligibleTiers.includes(tierKey);
        }));
    };
    StickyPriceWidget.prototype.renderTiers = function () {
        var _this = this;
        var tiers = new Map();
        var rows = [];
        tiers.set(services_1.ALLIANZ_ESSENTIALS, "Allianz Essentials");
        tiers.set(services_1.ALLIANZ_SILVER, "Allianz Silver");
        tiers.set(services_1.ALLIANZ, "Allianz");
        this.filterEligibleTiers(tiers).forEach(function (tierName, code) {
            var isChecked = _this.isChecked(code);
            var backgroundColorClass = isChecked ? "background-color-primary " : "background-color-grey ";
            var input = (React.createElement("div", { className: "col ".concat(backgroundColorClass), onClick: function (event) { return _this.handleChange(code); } },
                React.createElement("div", { className: "font-semi-bold tier-premium-display" },
                    React.createElement("div", { className: "custom-radiobutton-container" },
                        React.createElement("input", { className: "custom-radiobutton", type: "radio", name: _this.props.question.name, key: code + "input", value: code, id: _this.props.question.name + code, checked: isChecked, onChange: function (e) { return _this.handleChange(code); } })),
                    React.createElement("div", { className: "tier-name motor" }, tierName),
                    ((0, commonFunctions_1.hasPriceForTier)(code, _this.props.interaction.coverTier, _this.props.interaction.tieredFactors)) && _this.renderTierPremium(code))));
            rows.push(input);
        });
        return (React.createElement("div", { className: "journey-content" },
            React.createElement("div", { className: "row mr-0 ml-0 sticky-tiers sticky-tiers-motor" },
                React.createElement("div", { className: "col-4" }),
                rows)));
    };
    StickyPriceWidget.prototype.renderTierPremium = function (tier) {
        var factors = this.props.interaction.factors;
        var premiumType = factors.premiumType;
        var tierFactors = this.getTierFactors(tier);
        var annualPremium = tierFactors === null || tierFactors === void 0 ? void 0 : tierFactors.annualPremium;
        var monthlyPremium = tierFactors === null || tierFactors === void 0 ? void 0 : tierFactors.monthlyPremium;
        var tierWording = this.getTierWording(tier);
        var premium = premiumType === "annual" ? annualPremium : monthlyPremium;
        var premiumWording = premiumType === "annual" ? "year" : "month";
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "price" },
                (0, commonFunctions_1.getAmountWithDecimalDigits)(premium),
                React.createElement("span", { className: "margin-bottom-0 premium-type" },
                    " / ",
                    premiumWording,
                    "*")),
            React.createElement("span", { className: "tier-description tier-description-mobile-hidden" }, tierWording)));
    };
    StickyPriceWidget.prototype.getTierFactors = function (tierName) {
        var factors = this.props.interaction.tieredFactors;
        return factors ? factors.find(function (factor) { return factor.tier === tierName; }) : null;
    };
    StickyPriceWidget.prototype.getTierWording = function (tierName) {
        switch (tierName) {
            case "ALLIANZ_ESSENTIALS":
                return "Comprehensive car insurance that covers the basics.";
            case "ALLIANZ_SILVER":
                return "Comprehensive car insurance with more cover for your peace of mind.";
            default:
                return "Our highest level of comprehensive car insurance.";
        }
    };
    StickyPriceWidget.prototype.isChecked = function (id) {
        if (this.isDirectJourneyAndTierNotSelectedAndNB()) {
            return false;
        }
        return id === this.props.interaction.uistate.selectedCoverTier;
    };
    StickyPriceWidget.prototype.isDirectJourneyAndTierNotSelectedAndNB = function () {
        var _a;
        var source = (_a = this.props.interaction, _a.source), uistate = _a.uistate, process = _a.process;
        return !source && !uistate.selectedCoverTier && process === services_1.INTERACTION_PROCESS_NB;
    };
    StickyPriceWidget.prototype.handleChange = function (selectedTier) {
        if ((0, commonFunctions_1.hasPriceForTier)(selectedTier, this.props.interaction.coverTier, this.props.interaction.tieredFactors)) {
            journey_services_1.ObjectManipulator.setField("uistate.selectedCoverTier", this.props.interaction, selectedTier);
            (0, commonFunctions_1.handleChanged)(this.props.question.interactionField, this.props.interaction, this.state.initialTier, selectedTier);
            this.executeEvent("change");
        }
        else {
            this.toggleNoPriceForTierModal();
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], StickyPriceWidget.prototype, "customerPortalService", void 0);
    return StickyPriceWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=StickyPriceWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/StickyPriceWidget.js
// module id = 3652
// module chunks = 0